import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { NotificationBell } from "@faire/web--source/slate/icons/foundation/NotificationBell";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React, { useEffect, useState } from "react";
import styled, { keyframes, css } from "styled-components";
import { LeftStreak } from "@faire/retailer/components/Header/HeaderNotifications/__internal__/NotificationStreaks";
var ANIMATION_TIME = 2.5;
export var NotificationBellWithStreaks = function(param) {
    var _param_shouldAnimate = param.shouldAnimate, shouldAnimate = _param_shouldAnimate === void 0 ? false : _param_shouldAnimate, delayAnimationTime = param.delayAnimationTime;
    var _useState = _sliced_to_array(useState(false), 2), delayedShouldAniamte = _useState[0], setDelayedShouldAnimate = _useState[1];
    var isSSR = useIsSSR();
    useEffect(function() {
        if (delayAnimationTime) {
            var timer = setTimeout(function() {
                setDelayedShouldAnimate(shouldAnimate !== null && shouldAnimate !== void 0 ? shouldAnimate : false);
            }, delayAnimationTime !== null && delayAnimationTime !== void 0 ? delayAnimationTime : 2000);
            return function() {
                return clearTimeout(timer);
            };
        }
        return;
    }, [
        delayAnimationTime,
        shouldAnimate
    ]);
    var shouldAnimateIconOrDelay = delayAnimationTime ? delayedShouldAniamte : shouldAnimate;
    if (isSSR) {
        return /*#__PURE__*/ _jsx(BellIcon, {
            strokeWidth: 1,
            fontSize: "20px",
            $shouldAnimate: false
        });
    }
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(BellIcon, {
                strokeWidth: 1,
                fontSize: "20px",
                $shouldAnimate: shouldAnimateIconOrDelay
            }),
            shouldAnimateIconOrDelay ? /*#__PURE__*/ _jsx(_Fragment, {
                children: /*#__PURE__*/ _jsx(TopLeftStreak, {
                    $shouldAnimate: shouldAnimateIconOrDelay
                })
            }) : null
        ]
    });
};
var ring = keyframes([
    "0%,100%{transform:rotate(0);}20%,60%{transform:rotate(-10deg);}40%,80%{transform:rotate(10deg);}"
]);
var showLeftStreak = keyframes([
    "0%,40%,80%,100%{opacity:0;}20%,60%{opacity:1;}"
]);
var performAnimation = function(animation, time) {
    return css([
        "animation:",
        " ",
        "s ease;animation-fill-mode:both;"
    ], animation, time);
};
var TopLeftStreak = styled(LeftStreak).withConfig({
    componentId: "sc-7e93db1a-0"
})([
    "position:absolute;left:",
    ";top:",
    ";",
    "{left:9px;}",
    ";"
], getSpacing(6), getSpacing("1x"), responsiveMediaQueries.mobile, function(param) {
    var $shouldAnimate = param.$shouldAnimate;
    return $shouldAnimate && performAnimation(showLeftStreak, ANIMATION_TIME);
});
var BellIcon = styled(NotificationBell).withConfig({
    componentId: "sc-7e93db1a-1"
})([
    "position:relative;",
    ";"
], function(param) {
    var $shouldAnimate = param.$shouldAnimate;
    return $shouldAnimate && performAnimation(ring, ANIMATION_TIME);
});
